<template>
    <LmsBasicTemplate :current-page="navigationConfig.pageName" pageSubTitle="Membros" :searchField="true" searchPlaceholder="Pesquisar membro...">
        <template v-slot:navigation-side>
            <div class="dropdown mt-3">
                <span class="btn btn-secondary w-100 p-3" type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" @click="toggleMenu">
                    {{ selectedCourse || 'Escolha um curso' }}
                    <i v-if="dropdownMenuToggle" class="bi bi-chevron-down float-right"></i>
                    <i v-if="!dropdownMenuToggle" class="bi bi-chevron-up float-right"></i>
                </span>
        
                <ul class="dropdown-menu w-100" aria-labelledby="dropdownMenuLink" data-bs-target="#dropdownMenuLink"
                    aria-hidden="true">
                    <li v-for="course in userCourses" :key="course.id">
                        <a class="dropdown-item" href="#" @click.prevent="selectCourse(course, 1)">
                        {{ course.title }}
                        </a>
                    </li>
                </ul>
            </div>
            <ProfileNavigation></ProfileNavigation>

            <section class="mt-3">
                <div class="menu-buttons mt-3 d-flex flex-column gap-3">
                    <button v-for="(button, idx) in navigationConfig.navigation" :key="idx" type="button" class="btn py-3" @click.prevent="goTo(button.slug)">
                        <i v-if="button.icon" :class="button.icon"></i>
                        {{ button.name }}
                    </button>
                </div>
            </section>
        </template>
        <template v-slot:content-side>
            <div class="class-members">
                <div v-for="(student, index) in classMembers" :key="index" class="student_card">
                    <img :src="student.profile_photo_url" :alt="'student_'+index">
                    <div class="student_data">
                        <b class="student-name">{{student.name}}</b>
                        <p class="student-nick">@{{ student.nickname }}</p>

                    </div>
                    <button class="student_action_btn" v-if="
                    !student.user_friend_received &&
                    !student.user_friend_requested &&
                    !student.is_friend" @click="handleFriend('send', student.id)">
                        <svg width="21" height="16" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6562 3.5H16V4.84375H14.6562V6.15625H13.3438V4.84375H12V3.5H13.3438V2.15625H14.6562V3.5ZM5.34375 5.5C4.84375 5.5 4.38542 5.38542 3.96875 5.15625C3.57292 4.90625 3.25 4.58333 3 4.1875C2.77083 3.77083 2.65625 3.32292 2.65625 2.84375C2.65625 2.34375 2.77083 1.89583 3 1.5C3.25 1.08333 3.57292 0.760417 3.96875 0.53125C4.38542 0.28125 4.84375 0.15625 5.34375 0.15625C5.82292 0.15625 6.26042 0.28125 6.65625 0.53125C7.07292 0.760417 7.39583 1.08333 7.625 1.5C7.875 1.89583 8 2.34375 8 2.84375C8 3.32292 7.875 3.77083 7.625 4.1875C7.39583 4.58333 7.07292 4.90625 6.65625 5.15625C6.26042 5.38542 5.82292 5.5 5.34375 5.5ZM5.34375 6.15625C5.69792 6.15625 6.10417 6.19792 6.5625 6.28125C7.02083 6.34375 7.48958 6.44792 7.96875 6.59375C8.44792 6.73958 8.88542 6.91667 9.28125 7.125C9.69792 7.33333 10.0312 7.58333 10.2812 7.875C10.5312 8.16667 10.6562 8.48958 10.6562 8.84375V10.8438H0V8.84375C0 8.48958 0.125 8.16667 0.375 7.875C0.625 7.58333 0.947917 7.33333 1.34375 7.125C1.76042 6.91667 2.20833 6.73958 2.6875 6.59375C3.16667 6.44792 3.63542 6.34375 4.09375 6.28125C4.57292 6.19792 4.98958 6.15625 5.34375 6.15625ZM8.34375 0.1875C8.78125 0.25 9.17708 0.40625 9.53125 0.65625C9.88542 0.90625 10.1562 1.21875 10.3438 1.59375C10.5521 1.96875 10.6562 2.38542 10.6562 2.84375C10.6562 3.28125 10.5521 3.69792 10.3438 4.09375C10.1562 4.46875 9.88542 4.78125 9.53125 5.03125C9.17708 5.26042 8.78125 5.40625 8.34375 5.46875C8.65625 5.11458 8.89583 4.71875 9.0625 4.28125C9.25 3.82292 9.34375 3.34375 9.34375 2.84375C9.34375 2.34375 9.25 1.86458 9.0625 1.40625C8.89583 0.947917 8.65625 0.541667 8.34375 0.1875ZM11.0312 6.71875C11.4479 6.86458 11.8229 7.04167 12.1562 7.25C12.5104 7.45833 12.7917 7.69792 13 7.96875C13.2292 8.21875 13.3438 8.51042 13.3438 8.84375V10.8438H12V8.84375C12 8.40625 11.9062 8.01042 11.7188 7.65625C11.5521 7.30208 11.3229 6.98958 11.0312 6.71875Z" fill="currentColor"/>
                        </svg>
                        &nbsp;
                        Adicionar
                    </button>
                    <button class="student_action_btn on" v-else-if="
                    (student.user_friend_received || student.user_friend_requested)
                    && !student.is_friend" @click="handleFriend('cancel', student.id)">
                        <svg width="21" height="16" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6562 3.5H16V4.84375H14.6562V6.15625H13.3438V4.84375H12V3.5H13.3438V2.15625H14.6562V3.5ZM5.34375 5.5C4.84375 5.5 4.38542 5.38542 3.96875 5.15625C3.57292 4.90625 3.25 4.58333 3 4.1875C2.77083 3.77083 2.65625 3.32292 2.65625 2.84375C2.65625 2.34375 2.77083 1.89583 3 1.5C3.25 1.08333 3.57292 0.760417 3.96875 0.53125C4.38542 0.28125 4.84375 0.15625 5.34375 0.15625C5.82292 0.15625 6.26042 0.28125 6.65625 0.53125C7.07292 0.760417 7.39583 1.08333 7.625 1.5C7.875 1.89583 8 2.34375 8 2.84375C8 3.32292 7.875 3.77083 7.625 4.1875C7.39583 4.58333 7.07292 4.90625 6.65625 5.15625C6.26042 5.38542 5.82292 5.5 5.34375 5.5ZM5.34375 6.15625C5.69792 6.15625 6.10417 6.19792 6.5625 6.28125C7.02083 6.34375 7.48958 6.44792 7.96875 6.59375C8.44792 6.73958 8.88542 6.91667 9.28125 7.125C9.69792 7.33333 10.0312 7.58333 10.2812 7.875C10.5312 8.16667 10.6562 8.48958 10.6562 8.84375V10.8438H0V8.84375C0 8.48958 0.125 8.16667 0.375 7.875C0.625 7.58333 0.947917 7.33333 1.34375 7.125C1.76042 6.91667 2.20833 6.73958 2.6875 6.59375C3.16667 6.44792 3.63542 6.34375 4.09375 6.28125C4.57292 6.19792 4.98958 6.15625 5.34375 6.15625ZM8.34375 0.1875C8.78125 0.25 9.17708 0.40625 9.53125 0.65625C9.88542 0.90625 10.1562 1.21875 10.3438 1.59375C10.5521 1.96875 10.6562 2.38542 10.6562 2.84375C10.6562 3.28125 10.5521 3.69792 10.3438 4.09375C10.1562 4.46875 9.88542 4.78125 9.53125 5.03125C9.17708 5.26042 8.78125 5.40625 8.34375 5.46875C8.65625 5.11458 8.89583 4.71875 9.0625 4.28125C9.25 3.82292 9.34375 3.34375 9.34375 2.84375C9.34375 2.34375 9.25 1.86458 9.0625 1.40625C8.89583 0.947917 8.65625 0.541667 8.34375 0.1875ZM11.0312 6.71875C11.4479 6.86458 11.8229 7.04167 12.1562 7.25C12.5104 7.45833 12.7917 7.69792 13 7.96875C13.2292 8.21875 13.3438 8.51042 13.3438 8.84375V10.8438H12V8.84375C12 8.40625 11.9062 8.01042 11.7188 7.65625C11.5521 7.30208 11.3229 6.98958 11.0312 6.71875Z" fill="currentColor"/>
                        </svg>
                        &nbsp;
                        Solicitação enviada
                    </button>
                    <button class="student_action_btn on" v-else-if="student.is_friend" @click="handleFriend('remove', student.id)">
                        <svg width="17" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.3125 11.1562L6 8.84375L6.9375 7.90625L8.3125 9.28125L11.7188 5.84375L12.6562 6.78125L8.3125 11.1562ZM7.21875 4.71875C6.69792 5.23958 6.07292 5.5 5.34375 5.5C4.61458 5.5 3.97917 5.23958 3.4375 4.71875C2.91667 4.19792 2.65625 3.57292 2.65625 2.84375C2.65625 2.11458 2.91667 1.48958 3.4375 0.96875C3.97917 0.427083 4.61458 0.15625 5.34375 0.15625C6.07292 0.15625 6.69792 0.427083 7.21875 0.96875C7.73958 1.48958 8 2.11458 8 2.84375C8 3.57292 7.73958 4.19792 7.21875 4.71875ZM4 8.84375L6 10.8438H0V9.5C0 8.70833 0.604167 8.07292 1.8125 7.59375C3.04167 7.09375 4.21875 6.84375 5.34375 6.84375C5.65625 6.84375 5.875 6.85417 6 6.875L4 8.84375Z" fill="currentColor"/>
                        </svg>
                        &nbsp;
                        Amigo adicionado
                    </button>
                </div>
                
            </div>
            <pagination v-if="paginationOptions.show" v-model="paginationOptions.page" :records="paginationOptions.total" :per-page="paginationOptions.per_page" :options="paginationOptions" @paginate="callCoursePage"/>
            <div :class="!classMembers.length ? 'show-results' : 'hide-results'">
                <div class="no-results d-flex flex-column align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128" fill="none">
                    <path d="M128 56.0281C127.575 58.6521 127.275 61.3011 126.725 63.875C125.675 68.9731 123.8 73.7462 121.25 78.2694C119.775 80.8434 116.875 81.7431 114.4 80.3936C111.95 79.0441 111.075 76.0953 112.5 73.4963C116.275 66.624 118.15 59.3268 118 51.4799C117.65 31.8376 103.05 14.4943 83.7249 10.8208C62.5499 6.79735 42.0749 18.7677 35.1749 39.1847C26.9749 63.4502 42.6749 89.8399 67.9249 94.2882C77.8499 96.0375 87.2249 94.4631 96.0749 89.715C99.7999 87.7157 103.925 90.1148 103.75 94.1132C103.675 96.0625 102.675 97.4869 100.975 98.4116C94.7499 101.86 88.0749 104.009 80.9999 104.684C67.5999 105.984 55.4249 102.66 44.4999 94.788C43.7749 94.2632 43.0499 93.6884 42.2749 93.1136C41.9249 93.4385 41.6249 93.7134 41.3249 93.9883C30.7499 104.484 20.1749 115.005 9.5499 125.476C8.5499 126.476 7.2249 127.125 6.0249 127.95C5.3499 127.95 4.6999 127.95 4.0249 127.95C1.9999 127.3 0.674902 125.976 0.0249023 123.952C0.0249023 123.277 0.0249023 122.627 0.0249023 121.952C0.849902 120.778 1.5249 119.453 2.5249 118.454C13.0749 107.908 23.6499 97.4369 34.2249 86.941C34.5249 86.6412 34.7749 86.3413 35.0999 85.9914C34.7749 85.5666 34.4749 85.1667 34.1749 84.7669C27.2749 75.8954 23.4999 65.8243 23.0749 54.6037C22.5749 41.4838 26.4499 29.7134 34.7249 19.5174C42.7749 9.59625 53.1499 3.37368 65.7499 0.94963C67.8249 0.549786 69.9249 0.299883 72.0249 0C74.3499 0 76.6999 0 79.0249 0C79.2999 0.0749707 79.5749 0.174932 79.8499 0.199923C85.1249 0.574776 90.2499 1.72433 95.0749 3.79852C112.4 11.2706 123.15 24.2155 127.05 42.7083C127.475 44.7825 127.7 46.8817 128 48.9809C128 51.3549 128 53.704 128 56.0281Z" fill="#E1E1E1"/>
                    <path d="M0 124.002C0.65 126.026 1.975 127.35 4 128C2.675 128 1.325 128 0 128C0 126.675 0 125.326 0 124.002Z" fill="#E1E1E1"/>
                    <path d="M75.375 45.5822C78.725 42.2335 81.85 39.1097 84.975 35.9859C85.65 35.3112 86.3 34.6115 87.025 33.9617C89.125 32.0125 92.15 32.0375 94.1 34.0367C96.025 36.0109 96.05 39.0347 94 41.1089C90.55 44.6076 87.05 48.0562 83.6 51.5549C83.3 51.8547 83.025 52.1546 82.675 52.5295C83 52.8793 83.3 53.2292 83.625 53.5291C87.1 57.0027 90.6 60.4514 94.025 63.975C95.625 65.5994 95.95 67.6736 95.05 69.6228C94.2 71.4971 92.275 72.6716 90.225 72.5467C88.775 72.4467 87.625 71.772 86.625 70.7474C83.275 67.3737 79.925 64.025 76.55 60.6763C76.225 60.3514 75.9 60.0515 75.525 59.7017C75.15 60.0515 74.8 60.3514 74.5 60.6763C71.05 64.125 67.625 67.5736 64.15 70.9973C62.475 72.6466 60.375 72.9965 58.425 72.0968C56.55 71.2222 55.4 69.3229 55.55 67.2487C55.65 65.7993 56.35 64.6747 57.375 63.6751C61.05 60.0515 64.675 56.378 68.45 52.6294C68.125 52.2796 67.825 51.9547 67.525 51.6298C64.05 48.1562 60.55 44.7075 57.1 41.2089C55.45 39.5595 55.1 37.4354 56.05 35.4611C56.925 33.5869 58.85 32.4623 60.925 32.6123C62.325 32.7122 63.45 33.387 64.425 34.3616C67.775 37.7353 71.15 41.084 74.5 44.4326C74.725 44.6825 74.975 45.0824 75.375 45.5822Z" fill="#E1E1E1"/>
                  </svg>
                  <span class="w-50">Infelizmente, não conseguimos encontrar o que está procurando. Por favor, tente novamente.</span>
                </div>
              </div>
        </template>
    </LmsBasicTemplate>
</template>
<script>
    let emitter = require('tiny-emitter/instance');
    import LmsBasicTemplate from "./LmsBasicTemplate.vue";
    import {mapGetters} from "vuex";
    import ProfileNavigation from "@/components/lms/components/ProfileNavigation.vue";
    import CustomPagination from "@/components/lms/components/LmsHomeComponents/CustomPagination.vue";
    export default {
        name: 'LmsStudentClasses',
        data: () => ({
            navigationConfig: [],
            selectedCourse: null,
            lmsSlug: '',
            searchText: '',
            paginationOptions: {
                current_page: 1,
                paginationKey: 0,
                show: true,
                total: 0,
                page: 1,
                per_page: 0,
                template: CustomPagination
            },
            classMembers: [],
            dropdownMenuToggle: true
        }),
        components: {
            LmsBasicTemplate,
            ProfileNavigation
        },
        computed: {
            ...mapGetters({
                getLms: "LMS/getLms",
                getPageByName: "LMS/getPageByName",
                userCourses: 'LMS/getUserCourses',
                userClasses: 'LMS/getUserClasses',
                userId: 'store/id'
            })
        },
        beforeMount() {
            let root_ = this
            root_.navigationConfig = root_.getPageByName('LmsStudentClasses')
        },
        mounted() {
            let root_ = this
            
            root_.lmsSlug = root_.$route.params.lmsSlug
            root_.getUserCourses()
            .then(() => {
                root_.selectCourse(root_.userCourses[0], 1)
            })

            emitter.on('filter-courses', function (searchText) {
                root_.searchText = searchText;
                root_.selectCourse(root_.userCourses.filter(u => u.title == root_.selectedCourse)[0], root_.paginationOptions.current_page);
            });
        },
        beforeDestroy() {
            emitter.off('filter-courses');
        },
        methods: {
            getUserCourses() {
                let root_ = this
                root_.$parent.wait(true)
                return root_.$store.dispatch('LMS/getUserCourses', {slug: root_.lmsSlug}).then(() => {
                    root_.$parent.wait(false)
                })
            },
            toggleMenu(){
                this.dropdownMenuToggle = !this.dropdownMenuToggle;
            },
            callCoursePage(page) {
                console.log('page na call =>', page)
                return this.selectCourse(this.userCourses.filter(c => c.title == this.selectedCourse)[0], page)
            },
            selectCourse(course, page) {
                let root_ = this
                root_.$parent.wait(true)
                root_.selectedCourse = course.title
                let userClass = root_.userClasses.filter(c => c.course_id == course.id)
                
                root_.$store.dispatch('LMS/getClassMembers', {id: userClass[0].id, search: root_.searchText, page: page}).then((res) => {
                    root_.classMembers = Object.values(res.students.data)
                    root_.paginationOptions.current_page = res.students.current_page;
                    root_.paginationOptions.total = res.students.total;
                    root_.paginationOptions.per_page = res.students.per_page;
                    root_.paginationOptions.page = res.students.current_page;

                    root_.paginationOptions.show = root_.paginationOptions.total > root_.paginationOptions.per_page;
                    console.log('userclasses =>', root_.classMembers)
                    root_.$parent.wait(false)
                })
            },
            handleFriend(action ,id) {
                let root_ = this
                let payload = {}
                let userId = id
                root_.$parent.wait(true)
                switch (action) {
                    case 'send':
                        payload = {
                            "friend_id": id,
                        }
                    root_.$store.dispatch('Friends/AddFriend', payload).then( response => {
                        response;
                        this.classMembers = this.classMembers.map((s) => {
                            if (s.id == userId) {
                                s.user_friend_requested = true
                                s.user_friend_received = false
                                s.is_friend = false
                            }
                            return s
                        })
                        root_.$parent.wait(false)
                    }).catch( error => {
                        error;
                        root_.$parent.wait(false)
                    });
                    break;
                case 'cancel':
                    if(confirm('Tem certeza que deseja cancelar o pedido de amizade?')) {
                        payload = {
                            "friend_id": id,
                        }
                        root_.$store.dispatch('Friends/RemoveFriend', payload).then( response => {
                            response;
                            this.classMembers = this.classMembers.map((s) => {
                                if (s.id == userId) {
                                    s.user_friend_requested = false
                                    s.user_friend_received = false
                                    s.is_friend = false
                                }
                                return s
                            })
                            root_.$parent.wait(false)
                        }).catch( error => {
                            error;
                            root_.$parent.wait(false)
                        });
                    } else {
                        root_.$parent.wait(false)
                    }
                    break;
                case 'remove':
                    if(confirm('Tem certeza que deseja desfazer a amizade?')) {
                        payload = {
                            "friend_id": id,
                        }
                        root_.$store.dispatch('Friends/RemoveFriend', payload).then( response => {
                            response;
                            this.classMembers = this.classMembers.map((s) => {
                                if (s.id == userId) {
                                    s.user_friend_requested = false
                                    s.user_friend_received = false
                                    s.is_friend = false
                                }
                                return s
                            })
                            root_.$parent.wait(false)
                        }).catch( error => {
                            error;
                            root_.$parent.wait(false)
                        });
                    } else {
                        root_.$parent.wait(false)
                    }
                    break;
                default:
                    root_.$parent.wait(false)
                    break;
                }
            }
        }

    }
</script>
<style scoped lang="scss">
    
    #dropdownMenuLink {
        color: #706F6F;
        font-size: 16px;
        font-family: "Hanken Grotesk", sans-serif;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: left;
        border-radius: 10px;
        border: 1px solid #E1E1E1;
        background: #FFF;
        
    }
    
    .mycommunities {
        color: #706F6F;
        font-size: 16px;
        font-family: "Hanken Grotesk", sans-serif;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    
    .menu-buttons {
    
        .btn {
        color: #706F6F;
        background-color: #F6F6F6;
        font-size: 18px;
        font-family: "Hanken Grotesk", sans-serif;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: left;
    
        .bi {
            color: var(--buttons_color);
        }
        }
    
    }
    
    .VuePagination {
        display: flex;
        justify-content: center;
    }
    .class-members {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .class-members .student_card {
        transition: all 0.3s ease;
        width: 31%;
        border-radius: 20px;
        background: #FFF;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 30px 15px;
        margin: 0px 10px 20px;
        .student_action_btn {
            display: flex;
            align-items: center;
            color: #B1B1B1;
            font-size: 16px;
            font-family: Hanken Grotesk;
            &:hover {
                color: var(--buttons_color);
                cursor: pointer;
                svg {
                    fill: var(--buttons_color);
                }
            }
        }
        &:hover {
            -webkit-box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.3);
            -moz-box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.3);
            box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.3);
        }

        .student_action_btn.on {
            color: var(--buttons_color);
            svg {
                fill: var(--buttons_color);
            }
            &:hover {
                color: #B1B1B1;
                cursor: pointer;
                svg {
                    fill: #B1B1B1;
                }
            }
        }

        img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-bottom: 20px;
            object-fit: cover;
            object-position: center;
            -webkit-box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.3);
        }
    }
    .student_data {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 15px;
        color: #706F6F;
        text-align: center;
        font-family: Hanken Grotesk;
        .student-name {
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 5px;
        }

        .student-nick {
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }
    .student_action_btn {
        border: none;
        background-color: transparent;
    }
    .show-results {
        display: block;
        height: 100%;
    }
    .hide-results {
        display: none;
    }

    @media only screen and (max-width: 1400px) {

}

@media only screen and (max-width: 1200px) {

}

@media only screen and (max-width: 992px) {

}
@media only screen and (max-width: 768px) {
    .class-members {
        flex-direction: column;
        margin-top: 20px;
    }
    .class-members .student_card {
        width: 100%;
        padding: 30px 15px;
        margin: 0px 0px 15px;
        .student_action_btn {
            font-size: 12px;
        }
        img {
            width: 80px;
            height: 80px;
        }
    }
    .show-results {
        margin-top: 20px;
    }
}
@media only screen and (max-width: 480px) {
  
}
</style>